




















import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'

export default defineComponent({
  props: formFieldProps,
  setup(props) {
    const value = ref(null)
    const { specs, name } = props

    function onValue(v: Ref<any>) {
      value.value = v.value || []
    }

    const { valueChanged } = useClassifiedForm(props, { onValue })

    const extrasOptions = computed(() => specs.values)

    const handleExtrasChange = (extras: any[]) => {
      valueChanged(name, extras)
    }

    return { value, extrasOptions, handleExtrasChange }
  }
})
